import { p as palette } from '../base/color-DMp1DFwP.js';
import { s as spacing } from '../base/spacing-zNVNrnl_.js';
import { b as border } from '../base/border-7PxThjvv.js';

/* eslint-disable import/prefer-default-export */
const snackbar = {
  backgroundColor: palette.white,
  borderColor: 'transparent',
  borderWidth: border.roundedAreaThin.width,
  borderRadius: border.roundedAreaThin.radius,
  boxShadow: '0 4px 8px 0 rgb(35 47 63 / 0.20), 0 0 2px 0 rgb(35 47 63 / 0.30)',
  closeButton: {
    color: palette.gray[700],
    hoverColor: palette.squidInk
  },
  closeButtonHoverColor: palette.squidInk,
  marginBetween: spacing.base,
  padding: `${spacing.medium} ${spacing.base}`
};

export { snackbar as s };
//# sourceMappingURL=snackbar-BMox7zKO.js.map
